import { CustomCard } from '../Ocurrences/CustomCard/CustomCard';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const SpecialCares = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <CustomCard title="Cuidado Especial - Hipertensão" value={chartData?.specialCaresData?.hipertensao || 0} />
            <CustomCard title="Cuidado Especial - Diabetes" value={chartData?.specialCaresData?.diabetes || 0} />
            <CustomCard title="Cuidado Especial - Gestantes" value={chartData?.specialCaresData?.gestante || 0} />
            <CustomCard title="Cuidado Especial - < 1 ano" value={chartData?.specialCaresData?.recem_nascido || 0} />
        </div>
    );
};
